module.exports = __webpack_public_path__ + "static/media/cloud_infrastructureold.cacbc42b.svg";